import React from 'react';

import { ProductionKey } from 'src/constants/ProductionKey';
import {
  AzeiteOrOleoProductionStatus,
  FlocosProductionStatus,
  getAzeiteOrOleoProductionLabel,
  getFlocosProductionLabel,
  getMesocarpoProcessingLabel,
  MesocarpoProcessingStatus,
  ProcessingKey,
} from 'src/constants';

import { FilterChip } from 'src/styles/styledComponents';
import { ChipProps } from '@mui/material';

export default function StatusChip({
  type,
  status,
  size = 'small',
  variant = 'filled',
  ...otherProps
}: ChipProps & {
  type: ProductionKey | ProcessingKey;
  status?: AzeiteOrOleoProductionStatus | FlocosProductionStatus | MesocarpoProcessingStatus | null;
}) {
  if (!status) {
    return null;
  }

  let chipColor: 'info' | 'error' | 'default' | 'primary' | 'secondary' | 'success' | 'warning' =
    'info';
  let label = '';

  if (type === ProductionKey.FLOCOS) {
    const typedStatus = status as FlocosProductionStatus;
    switch (typedStatus) {
      case FlocosProductionStatus.IN_PRODUCTION:
        chipColor = 'default';
        break;
      case FlocosProductionStatus.READY_TO_REVIEW:
        chipColor = 'warning';
        break;
      case FlocosProductionStatus.REVIEWED:
        chipColor = 'info';
        break;
      case FlocosProductionStatus.COMPLETE:
        chipColor = 'success';
        break;
    }
    label = getFlocosProductionLabel({ status: typedStatus, shortName: true });
  } else if (type === ProductionKey.AZEITE || type === ProductionKey.OLEO) {
    const typedStatus = status as AzeiteOrOleoProductionStatus;
    switch (typedStatus) {
      case AzeiteOrOleoProductionStatus.READY_TO_PROCESS:
        chipColor = 'warning';
        break;
      case AzeiteOrOleoProductionStatus.COMPLETE:
        chipColor = 'success';
        break;
    }
    label = getAzeiteOrOleoProductionLabel({ status: typedStatus, shortName: true });
  } else {
    const typedStatus = status as MesocarpoProcessingStatus;
    switch (typedStatus) {
      case MesocarpoProcessingStatus.IN_PROGRESS:
        chipColor = 'warning';
        break;
      case MesocarpoProcessingStatus.COMPLETE:
        chipColor = 'success';
        break;
    }
    label = getMesocarpoProcessingLabel({ status: typedStatus, shortName: true });
  }
  return (
    <FilterChip
      color={variant !== 'filled' ? 'default' : chipColor}
      label={label}
      variant={variant}
      size={size}
      {...otherProps}
    />
  );
}
